export default __webpack_public_path__ + "static/media/Thumb_Top_05.68d35031.png";